<template>
  <section
    class="mc-rec-panel mc-rec-panel--products h-100 d-flex flex-column"
    :class="{ 'mc-rec-panel--products-compact': compact }"
  >
    <div class="mc-rec-panel__head mc-rec-panel__head--products">
      <div class="mc-rec-panel__head-text">
        <h2 class="mc-rec-panel__title">
          Produtos com melhor resultado
        </h2>
        <p v-if="!compact" class="mc-rec-panel__subtitle">
          Ranking por critério selecionado.
        </p>
      </div>
    </div>

    <div class="mc-rec-surface mc-rec-surface--products flex-grow-1 p-3 d-flex flex-column">
      <b-nav pills class="mc-rec-tabs mc-rec-tabs--compact flex-wrap mb-2">
        <b-nav-item :active="aba === 'recomendados'" @click="aba = 'recomendados'">
          Mais rec.
        </b-nav-item>
        <b-nav-item :active="aba === 'conversao'" @click="aba = 'conversao'">
          Conversão
        </b-nav-item>
      </b-nav>

      <div v-if="!listaExibicao.length" class="text-muted text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
        Nenhum produto no período.
      </div>
      <div v-else :class="compact ? 'mc-rec-products-stack' : 'mc-rec-products-list'">
        <div
          v-for="(item, idx) in listaExibicao"
          :key="item.product_id || idx"
          :class="compact ? 'mc-rec-product-mini' : 'mc-rec-product-row'"
        >
          <template v-if="compact">
            <div class="mc-rec-product-mini__thumb">
              <img v-if="item.link_imagem" :src="item.link_imagem" :alt="item.product_name">
            </div>
            <div class="mc-rec-product-mini__body">
              <a
                v-if="item.link_produto"
                :href="urlProduto(item.link_produto)"
                target="_blank"
                rel="noopener"
                class="mc-rec-product-mini__name"
              >
                {{ item.product_name }}
              </a>
              <span v-else class="mc-rec-product-mini__name">{{ item.product_name }}</span>
              <div class="mc-rec-product-mini__sub">
                {{ item.categoria || 'Produto' }}
              </div>
            </div>
            <div class="mc-rec-product-mini__value">
              <div v-if="aba === 'recomendados'" class="mc-rec-product-mini__metric-label">
                Vezes recomendado
              </div>
              <div v-else class="mc-rec-product-mini__metric-label">
                Vendas no período
              </div>
              <div class="mc-rec-product-mini__metric-num">
                {{ valorColunaPrincipal(item) }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="mc-rec-product-thumb">
              <img v-if="item.link_imagem" :src="item.link_imagem" :alt="item.product_name">
            </div>
            <div class="flex-grow-1 min-width-0">
              <a
                v-if="item.link_produto"
                :href="urlProduto(item.link_produto)"
                target="_blank"
                rel="noopener"
                class="font-weight-bold d-block text-truncate"
                style="color: #5b028c;"
              >
                {{ item.product_name }}
              </a>
              <span v-else class="font-weight-bold">{{ item.product_name }}</span>
              <div class="small text-muted">{{ item.categoria || 'Produto' }}</div>
            </div>
            <div class="text-right flex-shrink-0">
              <div v-if="aba === 'recomendados'" class="small text-muted text-uppercase" style="font-size: 0.65rem;">
                Vezes recomendado
              </div>
              <div v-else class="small text-muted text-uppercase" style="font-size: 0.65rem;">
                Vendas no período
              </div>
              <div class="font-weight-bold" style="color: #221c35;">
                {{ valorColunaPrincipal(item) }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BNav, BNavItem } from 'bootstrap-vue'

export default {
  name: 'RecommendationTopProducts',
  components: { BNav, BNavItem },
  props: {
    produtos: { type: Array, default: () => [] },
    /** Top conversão a partir de produtos_comprados em pedidos_convertidos (prioridade na aba Conversão) */
    produtosConversaoRanking: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  data() {
    return { aba: 'recomendados' }
  },
  computed: {
    listaBase() {
      if (this.aba === 'conversao' && this.produtosConversaoRanking && this.produtosConversaoRanking.length) {
        return this.produtosConversaoRanking.map(row => ({
          ...row,
          receita_gerada: row.receita_gerada != null ? row.receita_gerada : 0,
        }))
      }
      const list = (this.produtos || []).map(p => {
        let receitaGerada = 0
        if (p.receita_gerada != null) receitaGerada = p.receita_gerada
        else if (p.order_value_sum != null) receitaGerada = p.order_value_sum
        let pedidosGerados = null
        if (p.pedidos_gerados != null) pedidosGerados = p.pedidos_gerados
        else if (p.pedidos != null) pedidosGerados = p.pedidos
        return {
          ...p,
          receita_gerada: receitaGerada,
          pedidos_gerados: pedidosGerados,
          conversao_pct: p.conversao_pct != null ? `${p.conversao_pct}%` : null,
        }
      })
      if (this.aba === 'recomendados') {
        return [...list].sort((a, b) => (b.vezes_recomendado || 0) - (a.vezes_recomendado || 0))
      }
      return [...list].sort((a, b) => (parseFloat(b.conversao_raw) || 0) - (parseFloat(a.conversao_raw) || 0))
    },
    listaExibicao() {
      return this.listaBase.slice(0, 8)
    },
  },
  methods: {
    urlProduto(link) {
      if (!link) return '#'
      if (String(link).startsWith('http')) return link
      return link.startsWith('/') ? link : `/${link}`
    },
    displayConversao(item) {
      const v = item.conversao_pct
      return v != null && v !== '' ? v : '—'
    },
    valorColunaPrincipal(item) {
      if (this.aba === 'recomendados') {
        const n = item.vezes_recomendado
        return n != null && n !== '' ? String(n) : '—'
      }
      return this.displayConversao(item)
    },
  },
}
</script>
